import { VSheet } from 'vuetify/lib/components/VSheet';
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c(VSheet, {
    staticClass: "bridge-monitoring-charts pa-4",
    attrs: {
      "rounded": "",
      "color": _vm.panelColor
    }
  }, [_c(VSheet, {
    staticClass: "pa-3 mb-2",
    attrs: {
      "rounded": ""
    }
  }, [_c('div', {
    staticClass: "text-body-2 mb-1"
  }, [_vm._v(_vm._s(_vm.$i18n_t('Connectors.Monitoring.charts.packets')))]), _vm.isLoadingPackets ? _c(VSkeletonLoader, {
    staticStyle: {
      "height": "250px"
    },
    attrs: {
      "type": "image"
    }
  }) : _c('niota-classic-charts-line', {
    staticStyle: {
      "display": "flex",
      "justify-content": "center"
    },
    attrs: {
      "height": 200,
      "multi-chart-data-t": _vm.packetsChartData,
      "options": _vm.chartOptions
    }
  })], 1), _c(VSheet, {
    staticClass: "pa-3",
    attrs: {
      "rounded": ""
    }
  }, [_c('div', {
    staticClass: "text-body-2 mb-1"
  }, [_vm._v(_vm._s(_vm.$i18n_t('Connectors.Monitoring.charts.states')))]), _vm.isLoadingStates ? _c(VSkeletonLoader, {
    staticStyle: {
      "height": "250px"
    },
    attrs: {
      "type": "image"
    }
  }) : _c('niota-classic-charts-line', {
    staticStyle: {
      "display": "flex",
      "justify-content": "center"
    },
    attrs: {
      "height": 200,
      "multi-chart-data-t": _vm.statesChartData,
      "options": _vm.stateChartOptions
    }
  })], 1)], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };